import { Box, Typography } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Menu, MenuItem, CircularProgress } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useModal } from "../../../context/ModalContext.js";
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { UploadFile } from "@mui/icons-material";
import { useSettings } from "../../../context/Settings.js";

import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Stack,
  Skeleton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { get_property, get_property_delete, market_document_upload, market_uploaded_doc_delete, renew_market } from "../../../api/ControllApi";
import { toast } from "react-toastify";
import VerifyStatusDialog from "./VerifyStatusDialog.jsx";

const MyProperty = () => {

  const [selectedProperty, setSelectedProperty] = useState(null);
  const { settings } = useSettings()



  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const { openVerify } = useModal();
  const [loading, setLoading] = useState(true)
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [documents, setDocuments] = useState([])
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [openVerifyDialog, setOpenVerifyDialog] = useState(false);

  const totalAmount = settings?.data?.market_plot_verify_amount || 499



  const handleMenuOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };


  const get_property_list = () => {
    setLoading(true)
    get_property()
      .then((res) => {
        setProperties(res?.data);
        setDocuments(res?.data.documents)

      })
      .catch((err) => {

      })
      .finally(() => {
        setLoading(false)
      })
  };

  useEffect(() => {
    get_property_list();
  }, []);

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
    const validFiles = files.filter(file => allowedTypes.includes(file.type));

    if (validFiles.length === 0) {
      toast.error("Only PDF, JPEG, PNG files are allowed.");
      return;
    }

    setSelectedFiles(validFiles);
  };



  const [selectedPropertyForDocs, setSelectedPropertyForDocs] = useState(null);

  const openDocsDialogForProperty = (property) => {
    setSelectedPropertyForDocs(property);
    setDocuments(property.documents || []);
    setOpenViewDialog(true);
  };



  
  const getDelete = (id) => {
    get_property_delete(id)
      .then((res) => {
        toast.success(res?.message)

        get_property_list();

      })
      .catch((err) => {

      });
  };

  const handleRenew = async (id) => {
    try {
      const res = await renew_market(id);
      if (res?.status === true || res?.success === true || res?.status === "success" || res) {
        toast.success(res?.message || "Property renewed successfully");
        setProperties(prev => prev.map(p => p.id === id ? { ...p, status: 1 } : p));
        get_property_list();
      } else {
        toast.error(res?.message || "Failed to renew property");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong during renewal");
    }
  };


  const [selectedItem, setSelectedItem] = useState(null);
  const [openDocsDialog, setOpenDocsDialog] = useState(false); // dialog toggle


  const handleDocumentUpload = async (e, property) => {


    if (!property) return;

    const files = e.target.files;
    if (!files || files.length === 0) return;

    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
    const validFiles = Array.from(files).filter(file => allowedTypes.includes(file.type));

    if (validFiles.length === 0) {
      toast.error("Only PDF, JPEG, PNG files are allowed.");
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();
      validFiles.forEach(file => formData.append("file", file));
      formData.append("property_id", property.id);
      formData.append("type", "market")

      const res = await market_document_upload(formData); // your API
      toast.success(res?.message || "Documents uploaded successfully");


      // setDocuments(prev => [...prev, ...res?.data]);
    } catch (err) {

      toast.error("Failed to upload documents");
    } finally {
      setUploading(false);
      e.target.value = null;
    }
  };


  const submitDocuments = async () => {
    if (!selectedPropertyForDocs || selectedFiles.length === 0) return;

    try {
      setUploading(true);

      const formData = new FormData();
      selectedFiles.forEach(file => formData.append("file", file));
      formData.append("property_id", selectedPropertyForDocs.id);
      formData.append("type", "market");

      const res = await market_document_upload(formData);

      toast.success(res?.message || "Documents uploaded successfully");

      // refresh list or append docs
      get_property_list();

      setSelectedFiles([]);
      setOpenDocsDialog(false);
      setOpenUploadDialog(false);
    } catch (err) {

      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };


   const handleDeleteDoc = (id) => {
    market_uploaded_doc_delete(id)
      .then((res) => {
        toast.success(res?.message)

        get_property_list();
        setOpenViewDialog(false)

      })
      .catch((err) => {

      });
  };



  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
          alignItems: "center",
        }}
      >
        <Typography variant="h5">My Land List</Typography>

        <Button
          variant="contained"
          sx={{ bgcolor: "primary.main", gap: 1 }}
          onClick={() => navigate("/add-property")}
        >
          <AddIcon fontSize="small" />
          Add Property
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        sx={{ boxShadow: 1.5, overflowY: "auto", maxWidth: { md: "auto", lg: 800 } }}
      >
        <Table stickyHeader>
          <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
            <TableRow>
              <TableCell
                sx={{
                  maxWidth: 150,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Name
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: 150,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Category Type
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: 150,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Address
              </TableCell>

              <TableCell
                sx={{
                  maxWidth: 150,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Posted On
              </TableCell>


              {/* <TableCell
                sx={{
                  maxWidth: 150,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Documents
              </TableCell> */}



              {/* <TableCell
                sx={{
                  maxWidth: 150,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Upload Documents
              </TableCell> */}
              <TableCell
                sx={{
                  maxWidth: 150,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Verify Plot Pay
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: 150,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              // Array.from({ length: 5 }).map((_, index) => (
              //   <TableRow key={index}>
              //     {Array.from({ length: 11 }).map((_, cellIndex) => (
              //       <TableCell key={cellIndex}>
              //         <Skeleton variant="text" height={25} />
              //       </TableCell>
              //     ))}
              //   </TableRow>
              // ))
              <TableRow>
                <TableCell colSpan={11} align="center">
                  <Typography>Loading..</Typography>
                </TableCell>
              </TableRow>
            ) : properties.length > 0 ? (
              properties.map((item) => {
                const images = Array.isArray(item.image)
                  ? item.image
                  : typeof item.image === "string"
                  ? item.image.split(",")
                  : [];

                return (
                  <TableRow key={item.id}>
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1.5}>
                        <Typography variant="body2">{item.name}</Typography>
                        {(item?.status === 0 || item?.status === "0") && (
                          <Button
                            size="small"
                            variant="contained"
                            sx={{
                              bgcolor: "#FEB821",
                              color: "#fff",
                              fontWeight: 600,
                              textTransform: "none",
                              borderRadius: "6px",
                              py: 0.25,
                              px: 1,
                              minWidth: "auto",
                              "&:hover": {
                                bgcolor: "#e09a1f",
                              }
                            }}
                            onClick={() => handleRenew(item.id)}
                          >
                            Renew
                          </Button>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>{item.property_type?.category_name}</TableCell>

                    <TableCell>
                      {item.address?.length > 25
                        ? item.address.slice(0, 25) + "..."
                        : item.address}
                    </TableCell>


                    {/* 
                    <TableCell>
                      {item.plot_image ? (
                        <Avatar
                          src={item.plot_image}
                          variant="rounded"
                          sx={{ width: 50, height: 50 }}
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell> */}

                    <TableCell>
                      {new Date(item.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </TableCell>

                    {/* <TableCell>
                      {item.documents?.length > 0 ? (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => openDocsDialogForProperty(item)}
                        >
                          View ({item.documents.length})
                        </Button>
                      ) : (
                        <Typography variant="body2">No Docs</Typography>
                      )}
                    </TableCell> */}





                    {/* <TableCell>
                      <Button
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        setSelectedPropertyForDocs(item);
                        setSelectedFiles([]);
                        setOpenDocsDialog(true);
                      }}
                    >
                      Upload
                    </Button>

                    </TableCell> */}
                    {/* <TableCell>
                   
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          setSelectedPropertyForDocs(item);
                          setSelectedFiles([]);
                          setOpenUploadDialog(true);
                        }}
                      >
                        Upload
                      </Button>


                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        multiple
                        accept=".pdf,.jpeg,.jpg,.png"
                        onChange={(e) => handleDocumentUpload(e, selectedPropertyForDocs)}
                      />
                    </TableCell> */}

                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {

                          if (item?.doucment_verficaiton === false) {
                            setSelectedProperty(item);
                            setOpenVerifyDialog(true);
                          }

                          return

                        }}

                      >
                        {item?.doucment_verficaiton === false ? "Pay" : "Paid"}
                      </Button>



                    </TableCell>

                    <TableCell align="center">
                      <IconButton
                        size="small"
                        onClick={(e) => handleMenuOpen(e, item)}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                    </TableCell>



                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center">
                  <Typography>No data found</Typography>
                </TableCell>
              </TableRow>

            )}
          </TableBody>

        </Table>

      </TableContainer>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >


        <MenuItem
          onClick={() => {
            setSelectedPropertyForDocs(selectedItem);
            setSelectedFiles([]);
            setOpenUploadDialog(true); // open upload dialog
            handleMenuClose();
          }}
          sx={{ gap: 1 }}
        >
          <UploadFile fontSize="small" />
          Upload Documents
        </MenuItem>
        <MenuItem
          onClick={() => {
            navigate(`/edit-property/${selectedItem?.id}`);
            handleMenuClose();
          }}
          sx={{ gap: 1 }}
        >
          <EditIcon fontSize="small" />
          Edit
        </MenuItem>



        <MenuItem
          onClick={() => {

            getDelete(selectedItem?.id);
            handleMenuClose();
          }}
          sx={{ gap: 1, color: "error.main" }}
        >
          <DeleteIcon fontSize="small" />
          Delete
        </MenuItem>
      </Menu>


      <Dialog open={openViewDialog} onClose={() => setOpenViewDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>Documents</DialogTitle>



        <DialogContent dividers>

          {documents?.length === 0 ? (
            <DialogContentText>No documents uploaded.</DialogContentText>
          ) : (
            <ul style={{ padding: 0, listStyle: "none" }}>
              {documents?.map((doc, idx) => (
                <li
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 12px",
                    border: "1px solid #e0e0e0",
                    borderRadius: 6,
                    marginBottom: 10,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <PictureAsPdfIcon sx={{ color: "#d32f2f", fontSize: 28 }} />
                    <span style={{ fontWeight: 500 }}>
                      {"Property Document"}
                    </span>
                  </div>


                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <IconButton
                      component="button"
                      onClick={()=>handleDeleteDoc(doc?.id)}
                      color="primary"
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton> <IconButton
                      component="a"
                      href={doc.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="primary"
                      size="small"
                    >
                      <VisibilityIcon />
                    </IconButton>

                  </div>
                </li>
              ))}
            </ul>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <VerifyStatusDialog
        open={openVerifyDialog}
        totalPayableAmount={totalAmount}
        property_id={selectedProperty?.id}
        property_location={selectedProperty?.address}
        property_name={selectedProperty?.name}
        onClose={() => {
          setOpenVerifyDialog(false);
          setSelectedProperty(null);
        }}
      />



      <Dialog open={openUploadDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenUploadDialog(false);
        }} fullWidth maxWidth="sm">
        <DialogTitle>Upload Documents</DialogTitle>

        <DialogContent dividers>
          <input
            type="file"
            multiple
            accept=".pdf,.jpeg,.jpg,.png"
            onChange={handleFileSelect}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenUploadDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            // disabled={selectedFiles.length === 0 || uploading}
            onClick={submitDocuments}
          >
            {uploading ? (
              <CircularProgress size={22} sx={{ color: "white" }} />
            ) : (
              "Submit"
            )}
          </Button>



        </DialogActions>
      </Dialog>




    </Box>



  );
};

export default MyProperty;
